import dayjs, { Dayjs } from 'dayjs';

import DeliveryMode from '../models/DeliveryMode';

import type CourierService from '../models/CourierService';
import type RefundForm from '../models/RefundForm';

const getDefaultCourierService = (current: Dayjs): CourierService => ({
    start_time: current,
    end_time: current.add(1, 'day'),
    // -1 represents the new empty address field
    delivery_address_id: '-1',
    delivery_address: {
        address1: '',
        address2: '',
        city: '',
        country: 'HU',
        postcode: null,
        phone: '',
    },
});

export const getDefaultRefundFormValues = (): RefundForm => {
    const current = dayjs();

    return {
        mode: DeliveryMode.COURIER_SERVICE,
        products: [],
        reason: {
            id: 1,
            text: '',
            is_other_reason: false,
        },
        courier_service: getDefaultCourierService(current),
        transit: getDefaultCourierService(current),
        pickup_point: {
            store_location_id: 1,
            phone: '',
        },
        package_parameters: [],
    };
};
